package com.wintermar.inspection.feature.domain.usecase.inspection

import com.wintermar.inspection.core.domain.FlowResult
import com.wintermar.inspection.core.ui.component.image.util.FileModel
import com.wintermar.inspection.feature.domain.repository.InspectionRepository
import kotlinx.coroutines.flow.Flow

class DownloadInspectionReportUseCase(
    private val inspectionRepository: InspectionRepository
) {
    operator fun invoke(
        inspectionId: String
    ): Flow<FlowResult<FileModel>> {
        return inspectionRepository.downloadInspectionReport(inspectionId)
    }
}
